<!-- 下拉选择器组件分装 -->
<template>
	<div>
		<el-upload ref="upload" action="" :file-list="listPicUrls" :before-upload="beforeUpload" list-type="text">
			<i slot="default" class="el-icon-plus"></i>
			<ul class="el-upload-list el-upload-list--text" slot="file" slot-scope="{file}">
				<li class="el-upload-list__item is-success">
					<a class="el-upload-list__item-name" target="_blank" :href="file.url"><i
							class="el-icon-document"></i>附件{{ file.index }}</a>
					<label class="el-upload-list__item-status-label">
						<i class="el-icon-upload-success el-icon-circle-check"></i></label>
					<i class="el-icon-close" title="删除" @click="handlePictureRemove(file)"></i>
				</li>
			</ul>
		</el-upload>
	</div>
</template>

<script>
export default {
	name: "upload-attach-batch",
	props: ["urls"],
	data() {
		return {
			listPicUrls: "",
		}
	},
	watch: {
		urls: {
			handler(newValue) {
				this.listPicUrls = newValue
			},
			deep: true,
			immediate: true
		},
	},
	methods: {
		handleCallBack() {
			this.$emit("callBack", this.listPicUrls);
		},
		//预览图片时
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url
			this.dialogPicVisible = true
		},
		beforeUpload(file) {
			let formData = new FormData();
			formData.append('file', file);//传文件
			this.$axios.post('/comm/uploadfile', formData).then(res => {
				if (res.data.status == 0) {
					this.listPicUrls.push(
						{
							"id": 0, "url": res.data.data.showUrl, "dbUrl": res.data.data.dbPath, "index": 0
						}
					);
					this.listPicUrls.map((v,idx) =>v.index=idx+1)
					this.handleCallBack()
				}
				else {
					this.$message(res.data.msg);
				}
			})
			return false;
		},
		handlePictureRemove(file, fileList) {
			let index = this.listPicUrls.findIndex(item => item.dbUrl == file.dbUrl);
			if (index != -1) {
				this.listPicUrls.splice(index, 1);
			}
			this.listPicUrls.map((v,idx) =>v.index=idx+1)
			this.handleCallBack()
		},
	},
}
</script>

<style scoped lang="scss"></style>